

import { Card, FeatureButton, FeatureImage, FeatureText, FeatureTitle, FeatureDescription } from "./styles"
const NewCard = ({titleText, descriptionText, textButton, image, onClick, widthImage}) => {
    return (
        <Card>
        <FeatureImage widthImage={widthImage} src={image} />
        <FeatureText >
        <FeatureTitle>{titleText} </FeatureTitle>
        <FeatureDescription>{descriptionText}</FeatureDescription>
        <FeatureButton onClick={onClick}>  {textButton}</FeatureButton>
        </FeatureText>
      

        </Card>
    )
}
export default NewCard;